export default __webpack_public_path__ + "static/4-a1331e4f84dc906d0d66133b72ce2816.webp";